module.exports = __webpack_public_path__ + "img/20240603_txt2_04.20f4c379.png";